const PUBLIC_AUTH_PATHS = new Set(['/login', '/signup']);

export function isPublicAuthPath(pathname: string): boolean {
  return PUBLIC_AUTH_PATHS.has(pathname);
}
